// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__jR2WY","item":"PaymentsMobile_item__1dmjq","label":"PaymentsMobile_label__2aU5f","amount":"PaymentsMobile_amount__3HVDG"};